<template>
  <div>
    <h3 class="title dw_green--text font-weight-light">
      <v-icon color="dw_green" class="mr-2 mb-1" v-text="mdiStrategy" />
      MITRE ATT&amp;CK&reg; Techniques
    </h3>
    <v-row no-gutters>
      <v-col cols="11">
        <v-text-field
          v-model="search"
          @change="searchExisting"
          @click:clear="search = ''; searchExisting()"
          label="Search Techniques"
          :append-icon="mdiMagnify"
          color="dw_green"
          hide-details
          clearable
        ></v-text-field>
      </v-col>
    </v-row>
    <v-card width="33vw" max-height="50vh" class="pa-2 my-2 existing-list">
      <p v-for="teq of techniques" :key="teq" class="grey--text caption mb-1">{{ teq }}</p>
    </v-card>
  </div>
</template>

<script>
import { mdiStrategy, mdiMagnify } from '@mdi/js';
import { mapGetters } from 'vuex';

export default {
  name: 'techniqueList',
  data() {
    return {
      mdiStrategy,
      mdiMagnify,
      search: '',
      techniques: []
    }
  },
  computed: {
    ...mapGetters([
      'techniqueOptions'
    ])
  },
  mounted() {
    this.techniques = this.techniqueOptions.map((teq) => `${teq.mitre_id} ${teq.name}`);
  },
  methods: {
    searchExisting() {
      this.techniques = this.techniqueOptions.map((teq) => teq.name);
      if (this.search !== '') {
        this.techniques = this.techniques.filter((teq) => {
          const s = this.search.toLowerCase();
          return teq.toLowerCase().includes(s);
        });
      }
    }
  }
};
</script>

<style scoped>
.existing-list {
  height: inherit;
  overflow-y: scroll;
}
</style>
